module.exports = __webpack_public_path__ + "img/20251121_anniversary.bd89d95c.jpg";